<template>
    <div class="content">
        <div class="integral">
            <div class="personal-info">
                <div class="card-info">
                    <i :class="`icon icon-member icon-member-0${userLevel} l`"></i>
                </div>
                <div class="aside-info">
                    <div class="fix">
                        <div class="current-integral l">
                            <p class="l">有效积分</p>
                            <h3 class="l"><i class="number-font">{{ info.userPoint }}</i></h3>
                        </div>
                        <div class="freeze-point l" @click="showTip" v-if="info.freezePoint">
                            <span>冻结积分 {{info.freezePoint}}</span>
                            <i class="icon icon-question"></i>
                        </div>
                    </div>

                    <div class="integral-tip" v-if="info.expirePoint > 0">
                        <span>即将过期：{{info.expirePoint}}</span>
                        <em>|</em>
                        <span>有效期至：{{formateDate(info.pointExpireDateStr)}}</span>
                    </div>
                </div>
                <div class="recommend-tips" @click="showRecommendLayer">
                    <a>赚更多积分</a>
                </div>
                <div class="message-layer" v-if="msgShow">
                    <div class="message-content">
                        <div class="msg-text">
                            <i class="icon icon-warn"></i>
                            <div class="msg-tip" v-html="msgTip"></div>
                        </div>
                        <div class="bottom-btn">
                            <a class="btn-item btn-close" href="javascript: void(0)" @click="closeMsg">我知道了</a>
                        </div>
                        <a class="icon icon-close" href="javascript: void(0)" @click="closeMsg"></a>
                    </div>
                </div>
            </div>
            <div class="integral-list">
                <div class="list-hd">
                    <ul class="tab-box fix">
                        <li v-bind:class="{cur: activeIndex === 0}" @click="changeTab(0)">全部积分</li>
                        <li v-bind:class="{cur: activeIndex === 1}" @click="changeTab(1)">获得积分</li>
                        <li v-bind:class="{cur: activeIndex === 2}" @click="changeTab(2)">消耗积分</li>
                    </ul>
                    <div class="blank-box"></div>
                </div>
                <div class="list-bd">
                    <div class="list-item">
                        <ul class="fix">
                            <li class="des-item">积分类型</li>
                            <li class="des-item">交易日期</li>
                            <li class="des-item">有效期至</li>
                            <li class="des-item">积分</li>
                        </ul>
                    </div>
                    <div class="show-wrap" v-if="this.integralList.length > 0">
                        <div class="show-box">
                            <ul>
                                <li :class="`${item.changeValue > 0 ? 'type-increase' : 'type-decrease'} fix`" v-for="(item, index) in integralList" :key="index">
                                    <div class="des-item">
                                        <p class="comments-name">{{item.comments}}</p>
                                        <p v-if="item.remarks">{{item.remarks}}</p>
                                        <p v-if="item.outsideOrderNumber">关联单号：{{item.outsideOrderNumber}}</p>
                                    </div>
                                    <div class="des-item">
                                        <p>{{item.creationDateStr}}</p>
                                    </div>
                                    <div class="des-item">
                                        <p v-if="item.expireDateStr">{{item.expireDateStr}}</p>
                                    </div>
                                    <div class="des-item">
                                        <p class="point-num">{{item.changeValue}}</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="page-num fix">
                            <Page class="r" :current="pageIndex" :size="pageSize" :total="total" @on-change="changePage"></Page>
                        </div>
                    </div>
                    <div class="blank-tip" v-else>
                        <div class="tip-box">
                            <i class="icon icon-blank"></i>
                            <p>您还没有消耗任何积分哦！</p>
                            <a class="btn-item btn-obtain hvc" @click="handler">去兑换</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Loading :loading="loading"></Loading>
    </div>
</template>

<script>
    import axios from '@/libs/api.request'
    import { mapMutations } from 'vuex'
    import Page from '@/components/page'
    import Loading from '@/components/loading'
    export default {
        name: 'integralList',
        components: {
            Page,
            Loading
        },
        data: () => {
            return {
                info: {},
                userLevel: 1,
                pageSize: 10,
                pageIndex: 1,
                total: 0,
                loading: false,
                searchType: 0,
                integralList: [],
                activeIndex: 0,
                msgShow: false,
                msgTitle: '温馨提示',
                msgTip: '冻结积分包含通过船票预订、推荐<br>有礼等方式获得的待发放的积分'
            }
        },
        mounted () {
            this.loading = true

            this.getUserPoint()
                .then(res => {
                    this.info = res
                })
            this.getUserLevelPrivilege()
                .then(res => {
                    this.customerInfo = res.customerInfo
                    this.userLevel = this.getLevel(this.customerInfo.userLevel)

                    // 存储信息
                    this.storeInfo(res.customerInfo)
                    this.storePrivilegeList(res.privilegeList)
                })
            this.getUserMobile()
                .then(res => {
                    if (!this.customerInfo.fullName) {
                        this.customerInfo.fullName = res.mobile
                        this.customerInfo = Object.assign({}, this.customerInfo)

                        // 存储信息
                        this.storeInfo(this.customerInfo)
                    }
                })
            this.infiniteHandler(this.searchType)
                .then(res => {
                    this.integralList = res.data.rows
                    this.total = res.data.totalNum

                    this.loading = false
                })
        },
        methods: {
            ...mapMutations(['storeInfo', 'storePrivilegeList']),
            formateDate (time) {
                if (!time) return ''
                return time.replace(/-/g, '.')
            },
            showTip () {
                this.msgShow = true
            },
            closeMsg () {
                this.msgShow = false
            },
            getLevel (userLevelText) {
                switch (userLevelText) {
                    case '初级会员':
                        return 1
                    case '高级会员':
                        return 2
                    case '精英会员':
                        return 3
                    case '卓越会员':
                        return 4
                }
            },
            getUserPoint () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/CustomerInfo/ApiGetUserPoint',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            loyaltyId: this.$store.state.user.loyaltyId
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            getUserLevelPrivilege () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/CustomerInfo/ApiGetUserLevelPrivilege',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            loyaltyId: this.$store.state.user.loyaltyId
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            getUserMobile () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/Rccl.OpenApi/User/GetUserPoint',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            loyaltyId: this.$store.state.user.loyaltyId
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.success) {
                                resolve(data.data)
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            infiniteHandler (searchType) {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/CustomerInfo/ApiGetUserPointLog',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            loyaltyId: this.$store.state.user.loyaltyId,
                            searchType,
                            pageSize: this.pageSize,
                            pageIndex: this.pageIndex
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            changeTab (index) {
                this.activeIndex = index
                this.integralList = []
                this.pageIndex = 1
                this.total = 0
                this.loading = true
                if (index === 0) {
                    this.searchType = 0
                }
                if (index === 1) {
                    this.searchType = 10
                }
                if (index === 2) {
                    this.searchType = 20
                }
                this.infiniteHandler(this.searchType)
                    .then(res => {
                        this.integralList = res.data.rows
                        this.total = res.data.totalNum

                        this.loading = false
                    })
            },
            handler () {
                if (this.searchType === 0) {
                    window.location.href = '/'
                } else if (this.searchType === 10) {
                    window.location.href = '/'
                } else if (this.searchType === 20) {
                    this.$router.push('/member/shop/index')
                }
            },
            changePage (page) {
                this.pageIndex = page
                this.loading = true
                this.infiniteHandler(this.searchType)
                    .then(res => {
                        this.integralList = res.data.rows
                        this.loading = false
                    })
            },
            showRecommendLayer () {
                this.$store.commit('showRecommendLayer', true)
            }
        }
    }
</script>

<style lang="less" scoped>
    .integral{
        .personal-info{
            height: 106px;
            padding-top: 14px;
            background-color: #fff;
            .card-info{
                display: inline-block;
                vertical-align: middle;
                padding-left: 25px;
                .icon{
                    display: block;
                    width: 78px;
                    height: 78px;
                    &.icon-member-01{
                        background: url("https://resource.rcclchina.com.cn/logo/avatar_lv_01.png");
                    }
                    &.icon-member-02{
                        background: url("https://resource.rcclchina.com.cn/logo/avatar_lv_02.png");
                    }
                    &.icon-member-03{
                        background: url("https://resource.rcclchina.com.cn/logo/avatar_lv_03.png");
                    }
                    &.icon-member-04{
                        background: url("https://resource.rcclchina.com.cn/logo/avatar_lv_04.png");
                    }
                }
            }
            .aside-info{
                display: inline-block;
                vertical-align: middle;
                padding-left: 18px;
                .current-integral{
                    height: 22px;
                    p{
                        margin-top: 8px;
                        margin-right: 3px;
                        line-height: 1;
                    }
                    h3{
                        margin-top: -4px;
                        color: #ffa70d;
                        font-size: 30px;
                        line-height: 1;
                    }
                }
                .freeze-point{
                    height: 22px;
                    padding-right: 3px;
                    padding-left: 16px;
                    margin-left: 8px;
                    border-radius: 11px;
                    background-color: #01b5da;
                    color: #fff;
                    font-size: 0;
                    cursor: pointer;
                    &::before{
                        content: "";
                        display: inline-block;
                        vertical-align: middle;
                        width: 0;
                        height: 100%;
                    }
                    span{
                        display: inline-block;
                        vertical-align: middle;
                        font-size: 14px;
                        line-height: 18px;
                    }
                    .icon-question{
                        display: inline-block;
                        vertical-align: middle;
                        width: 17px;
                        height: 17px;
                        margin-left: 10px;
                        background: url("../../../assets/images/icon_question_2.png") no-repeat #fff;
                        background-size: 100% 100%;
                        border-radius: 50%;
                    }
                }
                .integral-tip{
                    padding-top: 7px;
                    line-height: 22px;
                    em{
                        position: relative;
                        top: -1px;
                        margin: 0 5px;
                    }
                }
            }
            .message-layer{
                position: fixed;
                left: 0;
                top: 0;
                z-index: 99;
                width: 100%;
                height: 100%;
                background-color: rgba(0,0,0,0.5);
                .message-content{
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    width: 320px;
                    height: 243px;
                    padding: 38px 54px 26px;
                    margin-top: -122px;
                    margin-left: -35px;
                    background-color: #fff;
                    border-radius: 4px;
                    border: #d5d9da solid 1px;
                    .icon-warn{
                        display: block;
                        width: 64px;
                        height: 64px;
                        margin: 0 auto;
                        background: url("../../../assets/images/warn.png") no-repeat;
                    }
                    .msg-tip{
                        padding-top: 12px;
                        line-height: 24px;
                        text-align: center;
                    }
                    .bottom-btn{
                        padding-top: 24px;
                        text-align: center;
                        .btn-close{
                            color: #0073bb;
                            font-size: 16px;
                        }
                    }
                    .icon-close{
                        position: absolute;
                        right: 10px;
                        top: 10px;
                        width: 29px;
                        height: 29px;
                        background: url("../../../assets/images/close.png") no-repeat center center #d3dadd;
                        background-size: 16px 16px;
                        border-radius: 50%;
                    }
                }
            }
            .recommend-tips {
                display: inline-block;
                margin-left: 20px;
                position: relative;
                top: 4px;
                a {
                    color: #006bad;
                    cursor: pointer;
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
        .integral-list{
            margin-top: 21px;
            margin-bottom: 84px;
            border-left: #d5dcdf solid 1px;
            .list-hd{
                height: 77px;
                .tab-box{
                    height: 57px;
                    border-bottom: #d5dcdf solid 1px;
                    li{
                        float: left;
                        width: 158px;
                        height: 56px;
                        line-height: 56px;
                        text-align: center;
                        border-right: #d5dcdf solid 1px;
                        border-top: #d5dcdf solid 1px;
                        background-color: #f3f6f8;
                        cursor: pointer;
                        &.cur{
                            height: 57px;
                            border-top: #006ab9 solid 3px;
                            background-color: #fff;
                            color: #006ab9;
                        }
                    }
                }
                .blank-box{
                    height: 20px;
                    background-color: #fff;
                    border-right: #d5dcdf solid 1px;
                }
            }
            .list-bd{
                border-right: #d5dcdf solid 1px;
                border-bottom: #d5dcdf solid 1px;
                background-color: #fff;
                .des-item{
                    display: inline-block;
                    vertical-align: middle;
                    &:nth-child(1){
                        width: 220px;
                        text-align: left;
                    }
                    &:nth-child(2){
                        width: 234px;
                        text-align: center;
                    }
                    &:nth-child(3){
                        width: 234px;
                        text-align: center;
                    }
                    &:nth-child(4){
                        width: 220px;
                        text-align: right;
                    }
                }
                .list-item{
                    padding: 0 20px;
                    background-color: #f5f5f5;
                    ul{
                        display: flex;
                        align-items: center;
                        li{
                            line-height: 36px;
                        }
                    }
                }
                .show-box{
                    padding: 0 20px;
                    ul{
                        li{
                            height: 81px;
                            border-bottom: #d4dbde solid 1px;
                            display: flex;
                            align-items: center;
                            .des-item{
                                min-height: 20px;
                                line-height: 20px;
                                font-size: 14px;
                                .comments-name{
                                    font-weight: bold;
                                }
                                .point-num{
                                    font-size: 24px;
                                }
                            }
                            &.type-increase{
                                .point-num{
                                    color: #ffa80f;
                                    &::before{
                                        content: "+";
                                    }
                                }
                            }
                            &.type-decrease{
                                .point-num{
                                    color: #0073bb;
                                }
                            }
                        }
                    }
                }
                .page-num{
                    padding: 20px;
                }
                .blank-tip{
                    height: 553px;
                    padding-top: 100px;
                    background-color: #fff;
                    .tip-box{
                        width: 230px;
                        margin: 0 auto;
                        text-align: center;
                        .icon-blank{
                            display: inline-block;
                            width: 146px;
                            height: 125px;
                            background: url("../../../assets/images/blank.png") no-repeat;
                            background-size: 100%;
                        }
                        p{
                            margin-top: 30px;
                            font-size: 16px;
                            color: #919b9f;
                            line-height: 20px;
                        }
                        .btn-obtain{
                            width: 135px;
                            height: 32px;
                            margin: 14px auto;
                            border: #53a1df solid 1px;
                            border-radius: 16px;
                            text-align: center;
                            color: #53a1df;
                            font-size: 16px;
                            line-height: 32px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
</style>
